export default __webpack_public_path__ + "static/media/soul-turquoise.18d376e9.png";